import { useContext } from "react";

import styled from "styled-components";
import { marginBottom } from "theme";

import FnrCard from "UI/FnrCard";

import { FnrAccordionContext } from "./FnrAccordion";
import { getMarginCorrectionAmount } from "./utils";

const { node } = require("prop-types");

const SFnrCard = styled(FnrCard)`
  ${({ $marginCorrection, $active, $marginCorrectionAmount: m }) =>
    $marginCorrection && !$active
      ? `margin: -${m}px 0 0 -${m}px; padding: 0 ${m}px;`
      : marginBottom}
  transition: border .05s, background-color .3s, padding .3s, border-radius .3s, margin .3s;
`;

const CardRelay = ({ children }) => {
  const {
    addCard,
    marginCorrection,
    active,
    noActiveMargin,
    dark,
    colorVariant,
  } = useContext(FnrAccordionContext);

  if (addCard) {
    const variant = active ? "accordion" : "hidden";
    return (
      <SFnrCard
        variant={variant} // for FnrCard
        $variant={variant} // for interpolations not going through FnrCard
        colorVariant={active ? colorVariant : ""}
        $active={active}
        $marginCorrection={marginCorrection}
        $marginCorrectionAmount={getMarginCorrectionAmount(marginCorrection)}
        $noActiveMargin={noActiveMargin}
        dark={dark}
      >
        {children}
      </SFnrCard>
    );
  }
  return children;
};

CardRelay.propTypes = {
  children: node,
};

export default CardRelay;
